import { builtEnvironment, isRunningLocal } from '.';

export const getBaseUrl = () => {
  const env = isRunningLocal() ? 'local' : builtEnvironment;
  return env === 'prod'
    ? 'https://app.waterlily.com'
    : env === 'dev'
      ? 'https://dev-app.waterlily.com'
      : 'https://localhost:5173';
};

export const isBaseUrlProd = () => {
  const baseUrl = getBaseUrl();
  return baseUrl.toLowerCase() === 'https://app.waterlily.com';
};

export const getIntegrationsUrl = () => {
  const env = isRunningLocal() ? 'local' : builtEnvironment;
  return env === 'prod'
    ? 'https://integrations.waterlily.com'
    : env === 'dev'
      ? 'https://dev-integrations.waterlily.com'
      : 'http://localhost:8787';
}

export default getBaseUrl;
